import React from 'react'

export default function Footer() {
    return (
        <React.Fragment>
            <footer class="generic-footer px-5">
                <div class="row section-row">
                    <div class="col-md-12">
                        <div class="d-flex flex-row-reverse">
                            <div class="p-2"><img src="/assets/img/ctara.svg" alt="CTARA"></img></div>
                            {/* <div class="p-2"><img src="assets/img/unicef.svg" alt="UNICEF"></img></div> */}
                            <div class="p-2"><img src="/assets/img/iitb.svg" alt="IIT Bombay"></img></div>
                            <div class="p-2"><img src="/assets/img/nhm_mh_logo.svg" alt="National Health Mission Maharashtra"></img></div>
                            <div class="p-2"><p class="credit">Developed in <br />Collaboration with</p></div>
                        </div>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    )
}
